export default "__VITE_ASSET__B0V5yIS2__"